import revFunnel from "@images/rev-funnel.svg";
import DataChart from "./DataChart";
import AgGridLoaderComponent from "@/components/loaders/AgGridLoaderComponent";
import { useSelector } from "react-redux";
import { IValueBoolean } from "@ts/common-types";
import { Select } from "antd";
import { useEffect, useState } from "react";
import { loadChart, populateCards } from "@/ts/funnel";
import { filter } from "underscore";
import { useGetModulesData } from "@/hooks/AllCustomHooks";

interface IBoolean {
    isDashboardLoading?: IValueBoolean;
}

const DashBoard = () => {
    const { Option } = Select;
    const { chartFilterOptions } = useGetModulesData({
        type: "dropdown-options",
    });

    const isDashboardLoading = useSelector(
        (state: IBoolean) => state.isDashboardLoading.value
    );
    const [activeProgramType, setActiveProgramType] = useState<string>(
        chartFilterOptions[chartFilterOptions.length - 1].value
    );
    const funnelResponse = JSON.parse(
        sessionStorage.getItem("funnel-response")
    );
    const programTypeHandler = (value: string) => {
        const filteredData =
            value !== "all"
                ? funnelResponse?.rows.filter(
                      (data: any) => data.program_type === value
                  )
                : funnelResponse?.totalRows;
        setActiveProgramType(value);
        sessionStorage.setItem("funnel-data", JSON.stringify(filteredData));
        populateCards(
            "performance-funnel",
            value !== "all"
                ? filter(
                      funnelResponse.comparedTotalByProgramType,
                      (data) => data.program_type === value
                  )[0]
                : funnelResponse.comparedTotal[0],
            false
        );
        const attributes = JSON.parse(sessionStorage.getItem("selectedCards"));
        attributes && loadChart(attributes);
    };

    useEffect(() => {
        chartFilterOptions &&
            setActiveProgramType(
                chartFilterOptions[chartFilterOptions.length - 1].value
            );
    }, [chartFilterOptions]);

    return (
        <>
            <div className="row" style={{ minHeight: "300px" }}>
                {isDashboardLoading ? (
                    <div className="d-flex align-items-center justify-content-center">
                        <span style={{ transform: "translate(-50%)" }}>
                            <AgGridLoaderComponent />
                        </span>
                    </div>
                ) : (
                    <>
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                            <div className="d-flex p-3 align-items-center">
                                <div
                                    className="col"
                                    id="funnel-report-filter"
                                    style={{
                                        fontSize: "13.5px",
                                        textAlign: "left",
                                    }}
                                />
                                {
                                    <Select
                                        className="me-sm-2 shadow-sm"
                                        size="small"
                                        options={chartFilterOptions}
                                        style={{ width: "8rem" }}
                                        value={activeProgramType}
                                        onChange={programTypeHandler}
                                    >
                                        <Option key={0} value="0" disabled>
                                            -- Select Profile --
                                        </Option>
                                    </Select>
                                }
                            </div>
                            <div
                                className="row row-cols-1 row-cols-sm-2 row-cols-md-1 row-cols-lg-2 gy-2 gy-lg-4 p-3"
                                id="funnel-report-cards"
                            >
                                <object
                                    id="performance-funnel"
                                    data={revFunnel}
                                    aria-label="funnel-chart"
                                />
                            </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 mt-4 mt-sm-0">
                            <div>
                                <figure className="highcharts-figure">
                                    <div id="funnel-report-render">
                                        <DataChart />
                                    </div>
                                </figure>
                                <div id="funnel-report-update" />
                            </div>
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default DashBoard;
